import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyUnitActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/PropertyUnit/PropertyUnitBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyUnit"
				RenderedComponent={this.RenderedComponent}
				context="PropertyUnit"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyUnitActivity)
